

export const ALL_GAMES_LIST=[
    'fastVocab','fastEnglish','concentration','vocabGame','describer','spellingBee','hangman','fastPhrases','grammarBubbles','falling',
    'jobs','perfect','food','comparatives','time','clothes','animalMystery','future','weather',
    'conditionals','phrasalVerbs','prepositions','pastTense','monsterPhrases', 'questions','presentSimple',
    'wordSearch','monsterVocab',
    'reveal','daysOfTheWeek','numbers',
    'bodyParts','dailyRoutines','monthsGame','family','vocab',
    'anagrams', 'adverbs', 'adverbsOfFrequency', 'adjectives', 'fastQuiz',
    'halloween', 'christmas'
];

export const SMALL_GAMES_LIST=[
    'fastVocab','fastEnglish','concentration','vocabGame','spellingBee','hangman',
    'wordSearch','monsterVocab','reveal','anagrams','vocab'
];